<template>
  <div class="layout-wrapper">
    <div class="container-fluid">
      <button class="btn btn-info mx-3" @click="onPrintClicked">پرینت</button>
      <button class="btn btn-warning mx-3" @click="onBackClicked">بازگشت</button>
        <toggle-button class="mt-2 mx-3" @change="pricechange($event)":labels="{unchecked: 'نمایش قیمت', checked: 'نمایش قیمت'}" :value="isActive" color="#82C7EB" :width="88" :height="25" :sync="true" />
        <toggle-button class="mt-2 mx-3" @change="title1change1($event)":labels="{unchecked: 'نمایش عنوان1', checked: 'نمایش عنوان1'}" :value="isActivet1" color="#82C7EB" :width="92" :height="25" :sync="true" />
        <toggle-button class="mt-2 mx-3" @change="title1change2($event)":labels="{unchecked: 'نمایش عنوان2', checked: 'نمایش عنوان2'}" :value="isActivet2" color="#82C7EB" :width="92" :height="25" :sync="true" />
      <div class="row mt-3 " id="printMe" style="background-color: white">

        <div class="col-12 mt-5">
          <div class="row mx-2 p-2">
            <div class="col-3 text-center  align-self-center" style="max-height: 170px !important;">
              <div>
                <img src="../../public/img/print-logo.jpg" class="logo-img">
              </div>
            </div>
            <div class="col-6 bold font-weight-bold font-2xl text-center align-self-center">
              رسید انبار شرکت
              {{app_name}}
            </div>
            <div class="col-3 text-left  align-self-center">
              <div class="row ">
              <span class="w-100 font-weight-bold">شماره سند :
              {{voucher.id}}</span>
              </div>
              <div class="row ">
              <span class="w-100">کاربر :
                {{username}} / {{company}} / {{post}} </span>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="col-12 mt-3">
          <div class="row mx-2 p-2 border text-right">
            <div class="col-2">تحویل دهنده :</div>
            <div class="col-2 font-weight-bold">{{voucher.serveName}}</div>
            <div class="col-2">تحویل گیرنده :</div>
            <div class="col-2 font-weight-bold">{{voucher.receiverName}}</div>
            <div class="col-2">نوع سند :</div>
            <div class="col-2 font-weight-bold">{{voucher.documentType.name}}</div>
          </div>
          <div class="row mx-2  p-2 border text-right">
            <div class="col-2">تاریخ فاکتور :</div>
            <div class="col-2 font-weight-bold">{{voucher.voucherDate}}</div>
            <div class="col-2">شماره فاکتور/بارنامه :</div>
            <div class="col-2 font-weight-bold">{{voucher.invoiceNumber}}</div>
            <div class="col-2">سفارش :</div>
            <div class="col-2 font-weight-bold">{{voucher.orderCode}}</div>
          </div>
          <div class="row mx-2 p-2 border text-right">
            <div class="col-3">نام تحویل دهنده/گیرنده :</div>
            <div class="col-2 font-weight-bold">{{voucher.voucherNumber}}</div>
            <div class="col-2">توضیحات :</div>
            <div class="col-5 font-weight-bold">{{voucher.description}}</div>
          </div>

        </div>
        <hr/>
        <div class="col-12 mt-5  ">
          <table class="table table-hover table-striped border text-center">
            <thead>
            <tr>
              <th class="text-center  border-right">ردیف</th>
              <th class="text-center  border-right">کد کالا</th>
              <th class="text-center  border-right">نام کالا</th>
              <th class="text-center  border-right" v-if="isActivet1">عنوان 1</th>
              <th class="text-center  border-right" v-if="isActivet2">عنوان 2</th>
              <th class="text-center  border-right">تعداد</th>
              <th class="text-center  border-right">واحد</th>
              <th class="text-center  border-right" v-if="isActive">فی</th>
              <th class="text-center  border-right border-left" v-if="isActive">قیمت</th>
            </tr>

            </thead>
            <tbody>
            <tr v-for="(i, index) in voucher.products">
              <td class="text-center   border-right text-nowrap">{{i.productId}}</td>
              <td class="text-center   border-right text-wrap">{{i.productCode}}</td>
              <td class="text-center   border-right text-wrap">{{i.productName}}</td>
              <td class="text-center   border-right text-wrap" v-if="isActivet1">{{i.title1}}</td>
              <td class="text-center   border-right text-wrap" v-if="isActivet2">{{i.title2}}</td>
              <td class="text-center   border-right text-nowrap">{{i.unitVal}}</td>
              <td class="text-center   border-right text-nowrap">{{i.unit.unitName}}</td>
              <td class="text-center   border-right text-nowrap" v-if="isActive">{{i.price.toLocaleString()}}</td>
              <td class="text-center   border-right text-nowrap border-left" v-if="isActive">{{i.total.toLocaleString()}}</td>

            </tr>
            <tr v-if="isActive">
              <td class="text-center   border-right " :colspan=cols ></td>
              <td class="text-center   border-right text-nowrap">جمع کل :</td>
              <td class="text-center   border-right border-left">{{voucher.price.toLocaleString()}}</td>
            </tr>

            </tbody>
          </table>

        </div>
        <hr/>
        <div class="col-12  ">
          <div class="row border mx-2  text-right">
            <div class="col-2 p-3 border-bottom">صادر کننده/انباردار :</div>
            <div class="col-2 p-3 border-bottom font-weight-bold"></div>
            <div class="col-2 p-3 border-bottom border-right">کنترل کیفیت :</div>
            <div class="col-2 p-3 border-bottom font-weight-bold"></div>
            <div class="col-2 p-3 border-bottom border-right">مدیر :</div>
            <div class="col-2 p-3 border-bottom font-weight-bold"></div>

            <div class="col-4 p-3">محل امضاء :</div>
            <div class="col-4 p-3 border-right">محل امضاء :</div>
            <div class="col-4 p-3 border-right">محل مهر و امضاء :</div>

            <div class="col-4"><i style="visibility: hidden">www</i></div>
            <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
            <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
            <div class="col-4"><i style="visibility: hidden">www</i></div>
            <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
            <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .logo-img {
    max-height: 130px;
    max-width: 130px;

  }

  .rotated-text {
    /*-webkit-transform: rotate(-90deg);*/
    /*-ms-transform: rotate(-90deg);*/
    transform: rotate(-90deg);

    /*font-size: larger;*/
  }

  .print-style {
    direction: rtl !important;
    font-family: 'Shabnam';
    src: url('/font//Shabnam-FD.woff2') format('woff2'),
    url('/font/Shabnam-FD.woff') format('woff');
    font-weight: normal;
  }

</style>
<script>
  import BaseService from "../_framework/api/BaseService";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import VsSelect from "../_framework/VsSelect";
  import Utils from "../_framework/utils/Utils";
  import Moment from 'moment-jalali';
  // import Constants from "../_framework/Constants";
  import VueHtmlToPaper from 'vue-html-to-paper';
  import Vue from 'vue';
  import Constants from "../Constants";
  import ToggleButton from "vue-js-toggle-button/src/Button";


  export default {
    name: "printVoucher",
    components: {VsSelect, DatePicker,  ToggleButton},
    data() {
      return {
        cols:6,
        company: "",
        post: "",
        username: "",
        app_name: "",
        mysampleSeris: [],
        sampleId: 0,
        serinum: 0,
        companyModel: {},
        ensampleAge: [],
        aver: 0,
        voucher: {},
        voucherId: 0,
        isActive: true,
        isActivet1: true,
        isActivet2: true,
      }
    },
    mounted() {
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "شرکت آبان توسعه / پرینت رسید انبار"

      };
      Vue.use(VueHtmlToPaper, printoptions);

      this.app_name = Constants.APP_NAME;
      this.company = localStorage.getItem("company");
      this.post = localStorage.getItem("post");
      this.username = localStorage.getItem("username");

      if (this.$route.params.id !== undefined) {
        this.voucherId = this.$route.params.id;
        this.getVoucherData();
      } else {

      }
      this.colsCalc();
    },
    methods: {
      colsCalc(){
        if(this.isActivet1){
          if(this.isActivet2){
            this.cols = 7;
          }else {
            this.cols = 6;
          }
        }else{
          if(this.isActivet2){
            this.cols = 6;
          }else {
            this.cols = 5;
          }
        }
      },
      pricechange(e) {
        this.isActive = !this.isActive;
        this.text = this.isActive ? "کالاهای موجود" : "تمام کالاها";
      },
      title1change1(e) {
        this.isActivet1 = !this.isActivet1;
        this.text = this.isActivet1 ? "کالاهای موجود" : "تمام کالاها";
        this.colsCalc();
      },
      title1change2(e) {
        this.isActivet2 = !this.isActivet2;
        this.text = this.isActivet2 ? "کالاهای موجود" : "تمام کالاها";
        this.colsCalc();
      },
      onBackClicked() {
        this.$router.push({name: "اسناد انبار"});
      },
      onPrintClicked() {
        const title = document.title;
        document.title = "سند انبار : " + this.voucher.id;
        this.$htmlToPaper('printMe');
        document.title = title;
      },
      getVoucherData() {
        new BaseService(`Voucher/${this.voucherId}`).getList().then(response => {
          const vouch = response.data;
          for (let i of vouch.products) {
            i.isoCode ="safsdfsf";
            new BaseService("Products/GetProductDetail").getById(i.productId).then(rs => {
              let details =  rs.data ;
              if(details.customerName !== null && details.customerName !== ""){
                i.productName = details.customerName;
              }
              i.isoCode =details.isoCode;
            });
          }
          this.voucher = vouch;
          console.log(this.voucher.products);
          // let date = Moment(this.voucherModel.voucherDate, "jYYYY/jMM/jDD");
          // this.voucherModel.voucherDate = date.format("YYYY/MM/DD");
        }).catch(error => {
          console.log(error);
          Utils.handleErrorWithNotification(error.data, this.$noty);
        });
      },


    },

  }
</script>

<style lang="scss" scoped>
  .profile-image {
    margin: 0 auto 1rem auto;
  }

  .profile-image img {
    max-width: 150px;
    border-radius: 1rem;
    box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
  }
</style>
